export const COLOR = {
  // Primary
  brightBlue: 'hsl(220, 98%, 61%)',
  checkBackground:
    'linear-gradient(135deg, hsl(192, 100%, 67%), hsl(280, 87%, 65%))',

  // Neutral
  white: '#fff',

  // Light Theme
  lightBackground: 'hsl(0, 0%, 98%)',
  lightListItems: 'hsl(235, 19%, 35%)',
  lightFooter: 'hsl(236, 9%, 61%) ',
  lightCheckBorder: 'hsl(236, 33%, 92%)',
  lightDoneItems: 'hsl(233, 11%, 84%)',
  lightShadow: 'hsla(235, 19%, 80%, 0.5)',
  lightInput: 'hsl(235, 14%, 26%)',

  // Dark Theme
  darkBackground: 'hsl(235, 21%, 11%)',
  darkListBackground: 'hsl(235, 24%, 19%)',
  darkListItems: 'hsl(234, 39%, 85%)',
  darkFooter: 'hsl(235, 16%, 43%)',
  darkCheckBorder: 'hsl(237, 14%, 26%)',
  darkDoneItems: 'hsl(233, 14%, 35%)',
  darkShadow: 'hsla(0, 0%, 0%, 0.5)',
  darkPlaceholder: 'hsl(234, 11%, 52%)',
};
